export const HOME_CTA_BANNER = {
  title: "지금 바로 교육을 시작해보세요",
  subtitle: "온라인 수강 · 전체 강의 완료 후 수료증 제공",
  cta: {
    label: "서비스 소개 바로가기",
    to: "/courses",
  },
};
